import { createWebHistory, createRouter } from "vue-router";

const routes = [
  // Use lazy-loaded route components to reduce initial bundle size
  { path: "/", component: () => import("../components/Pages/HomePageOne") },
  { path: "/home-two", component: () => import("../components/Pages/HomePageTwo") },
  { path: "/home-three", component: () => import("../components/Pages/HomePageThree") },
  { path: "/about-us", component: () => import("../components/Pages/AboutUsPage") },
  { path: "/services", component: () => import("../components/Pages/ServicesPage") },
  { path: "/single-services", component: () => import("../components/Pages/SingleServicePage") },
  { path: "/service-one", component: () => import("../components/Pages/ServicePageOne") },
  { path: "/service-two", component: () => import("../components/Pages/ServicePageTwo") },
  { path: "/service-three", component: () => import("../components/Pages/ServicePageThree") },
  { path: "/pricing", component: () => import("../components/Pages/PricingPage") },
  { path: "/faqs", component: () => import("../components/Pages/FaqPage") },
  { path: "/our-team", component: () => import("../components/Pages/TeamPage") },
  { path: "/projects", component: () => import("../components/Pages/ProjectsPage") },
  { path: "/single-project", component: () => import("../components/Pages/SingleProjectsPage") },
  { path: "/cases", component: () => import("../components/Pages/CasesStudyPage") },
  { path: "/cases-two-columns", component: () => import("../components/Pages/CasesStudyTwoPage") },
  { path: "/single-case", component: () => import("../components/Pages/SingleCasesStudyPage") },
  { path: "/single-news-1", component: () => import("../components/Pages/SingleNewsOnePage") },
  { path: "/single-news-2", component: () => import("../components/Pages/SingleNewsTwoPage") },
  { path: "/single-news-3", component: () => import("../components/Pages/SingleNewsThreePage") },
  { path: "/single-news-4", component: () => import("../components/Pages/SingleNewsFourPage") },
  { path: "/testimonial", component: () => import("../components/Pages/TestimonialPage") },
  { path: "/our-clients", component: () => import("../components/Pages/OurClientsPage") },
  { path: "/careers", component: () => import("../components/Pages/CareersPage") },
  { path: "/products", component: () => import("../components/Pages/ProductsPage") },
  { path: "/single-product", component: () => import("../components/Pages/SingleProductsPage") },
  { path: "/cart", component: () => import("../components/Pages/CartPage") },
  { path: "/checkout", component: () => import("../components/Pages/CheckoutPage") },
  { path: "/authentication", component: () => import("../components/Pages/AuthenticationPage") },
  { path: "/forget-password", component: () => import("../components/Pages/ForgetPasswordPage") },
  { path: "/my-account", component: () => import("../components/Pages/MyAccountPage") },
  { path: "/my-orders", component: () => import("../components/Pages/MyOrdersPage") },
  { path: "/my-addresses", component: () => import("../components/Pages/MyAddressesPage") },
  { path: "/demo-product", component: () => import("../components/Pages/DemoProductPage") },
  { path: "/feedback", component: () => import("../components/Pages/FeedbackPage") },
  { path: "/terms-of-service", component: () => import("../components/Pages/TermsOfServicePage") },
  { path: "/privacy-policy", component: () => import("../components/Pages/PrivacyPolicyPage") },
  { path: "/search-page", component: () => import("../components/Pages/SearchPage") },
  { path: "/news", component: () => import("../components/Pages/NewsPage") },
  { path: "/:pathMatch(.*)*", component: () => import("../components/Pages/ErrorPage") },
  { path: "/coming-soon", component: () => import("../components/Pages/ComingSoonPage") },
  { path: "/blogs", component: () => import("../components/Pages/BlogPage") },
  { path: "/blogs-right-sidebar", component: () => import("../components/Pages/BlogRightSidebarPage") },
  { path: "/single-blog", component: () => import("../components/Pages/SingleBlogPage") },
  { path: "/contact", component: () => import("../components/Pages/ContactPage") },
  { path: "/contact-success", component: () => import("../components/Pages/ContactSuccessPage") },
  { path: "/product-one", component: () => import("../components/Pages/ProductPageOne") },
  { path: "/product-two", component: () => import("../components/Pages/ProductPageTwo") },
  { path: "/product-three", component: () => import("../components/Pages/ProductPageThree") },
  { path: "/product-four", component: () => import("../components/Pages/ProductPageFour") },
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
